const heroVideo = {
  MOBILE_BP: 782,

  init(root, options = {}) {
    const scope = root || document;
    const blocks = [];

    if (scope.matches && scope.matches('.hero-home')) {
      blocks.push(scope);
    }

    if (scope.querySelectorAll) {
      blocks.push(...scope.querySelectorAll('.hero-home'));
    }

    blocks.forEach((block) => this.bindBlock(block, options));
  },

  bindBlock(block, options = {}) {
    if (block.dataset.heroReady === 'true') {
      return;
    }

    block.dataset.heroReady = 'true';

    if (block.matches('.hero-home--video')) {
      this.loadCurrentVideo(block, options);

      // The canvas resizes constantly as panels open; the frontend does not.
      if (!options.isEditor) {
        window.addEventListener('resize', () => this.loadCurrentVideo(block, options));
      }
    }

    this.initYoutubeFacades(block, options);
  },

  loadCurrentVideo(block, options = {}) {
    const isMobile = block.ownerDocument.defaultView.innerWidth < this.MOBILE_BP;
    const desktopVideo = block.querySelector('.hero-home__video--desktop');
    const mobileVideo = block.querySelector('.hero-home__video--mobile');
    const video = isMobile ? mobileVideo : desktopVideo;

    if (!video || video.src || !video.dataset.src) {
      return;
    }

    video.src = video.dataset.src;
    video.load();

    // Otherwise the editor plays video while you type.
    if (!options.isEditor) {
      video.play();
    }
  },

  initYoutubeFacades(block, options = {}) {
    block.querySelectorAll('.hero-home__yt-facade').forEach((facade) => {
      facade.addEventListener('click', () => {
        // Keeps a third-party player out of the editor.
        if (options.isEditor) {
          return;
        }

        // Released by the Axeptio script in the footer once the visitor consents.
        if (facade.getAttribute('data-consent-required') === 'youtube') {
          if (window.openAxeptioCookies) window.openAxeptioCookies();
          return;
        }

        const id = facade.dataset.ytId;
        if (!id) return;

        const iframe = facade.ownerDocument.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.title = 'YouTube video player';

        facade.innerHTML = '';
        facade.appendChild(iframe);
      });
    });
  },
};

export default heroVideo;

if (!window.acf) {
  window.addEventListener('DOMContentLoaded', () => heroVideo.init(document, { isEditor: false }));
}
